import {createUseStyles} from 'react-jss';

export default createUseStyles({
  switchContainer: {
    width: 50,
    height: 20,
    backgroundColor: "#d0d0d0",
    borderRadius: 50,
    position: 'relative',
    cursor: 'pointer',
    transition: '0.3s',
  },

  indicator: {
    width: 25,
    height: 25,
    position: 'absolute',
    borderRadius: '50%',
    top: -2.5,
    transition: '0.2s',
    left: 0,
    backgroundColor: "#004f9f"
  }
})